import { makeStyles } from '@material-ui/core/styles';

const defaultValues = {
  lineHeight: '2px',
  defaultColor: '#0D1835FF',
};

const useStyles = makeStyles(() => ({
  dividerWithTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: props => (props.color ? props.color : defaultValues.defaultColor),
    whiteSpace: 'nowrap',
    marginTop: '10px',
    fontWeight: 'bold',
  },
  divider: {
    width: '100%',
    height: props =>
      props.lineHeight ? `${props.lineHeight}px` : defaultValues.lineHeight,
    background: props =>
      props.color ? props.color : defaultValues.defaultColor,
  },
}));

export default useStyles;
